import React from 'react';
import { makeStyles } from 'design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import ExamplePreview from './examplePreview';

const ExampleClassification = ({
  linkedTask,
  updateQuiz,
  isCorrect,
  response,
  index,
}: {
  linkedTask?: string;
  updateQuiz: (response: string) => void;
  isCorrect?: boolean;
  response?: string;
  index: number;
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3>{index}. Is this labelled correctly?</h3>
      {isCorrect !== undefined && !response && (
        <div className={classes.error}>This question is not complete.</div>
      )}

      {isCorrect === false && response && (
        <div className={classes.error}>
          This answer is incorrect, please change and resubmit. If you’re stuck check out the
          instructions
        </div>
      )}
      <div className={classes.exampleContainer}>
        {linkedTask && <ExamplePreview linkedTask={linkedTask} />}
      </div>
      <div className={classes.optionWrapper}>
        {[
          { description: 'Yes', option: 'good' },
          { description: 'No', option: 'bad' },
        ].map(({ description, option }, idx) => {
          const selected = response === option;
          return (
            <div
              className={cx(classes.optionBox, {
                [classes.selected]: selected,
                [classes.correct]: selected && isCorrect,
                [classes.incorrect]: selected && isCorrect === false,
              })}
              key={idx}
              onClick={() => updateQuiz(option)}
            >
              {selected && typeof isCorrect === 'boolean' && (
                <FontAwesomeIcon icon={isCorrect ? 'check' : 'times'} />
              )}
              {'   ' + description}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    background: 'white',
    padding: 20,
    borderRadius: 8,
    border: `1px solid ${theme.colors.gray10}`,
    marginTop: 20,
  },
  optionBox: {
    border: `1px solid ${theme.colors.gray50}`,
    padding: 10,
    textAlign: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  selected: {
    background: 'rgba(43, 153, 216, 0.05)',
    color: theme.colors.blue,
    border: `1px solid ${theme.colors.blue}`,
  },

  optionWrapper: {
    display: 'flex',
    marginTop: 20,
    '& > div': {
      flex: 1,
    },

    '& > div:first-child': {
      borderRadius: '8px 0 0 8px',
    },
    '& > div:last-child': {
      borderRadius: '0 8px 8px 0',
    },
  },

  exampleContainer: {
    borderRadius: 8,
    overflow: 'hidden',
    'box-shadow': 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
  },

  correct: {
    background: '#EAFAF6',
    color: '#03A574',
    border: '1px solid #03A574',
  },

  incorrect: {
    background: '#FDEEEE',
    color: '#B71C1C',
    border: '1px solid #B71C1C',
  },

  error: {
    color: theme.colors.red,
    margin: '10px 0',
    fontWeight: 500,
  },
}));

export default ExampleClassification;
